import {
  AfterViewInit,
  Directive,
  ElementRef,
  NgZone,
  OnDestroy,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[flipAnimate]'
})
export class FlipAnimateDirective implements AfterViewInit, OnDestroy {
  private observer: MutationObserver;

  constructor(
    private el: ElementRef,
    private zone: NgZone,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    const native = this.el.nativeElement;

    this.zone.runOutsideAngular(() => {
      let prevRects: Map<Element, DOMRect> = new Map();

      const snapshot = () => {
        prevRects.clear();
        native.childNodes.forEach((node: any) => {
          if (node.nodeType === 1) {
            prevRects.set(node, node.getBoundingClientRect());
          }
        });
      };

      const animate = () => {
        native.childNodes.forEach((node: any) => {
          if (node.nodeType !== 1) return;

          const newRect = node.getBoundingClientRect();
          const oldRect = prevRects.get(node);

          if (!oldRect) return;

          const dx = oldRect.left - newRect.left;

          if (dx !== 0) {
            this.renderer.setStyle(node, 'transition', 'none');
            this.renderer.setStyle(node, 'transform', `translateX(${dx}px)`);

            requestAnimationFrame(() => {
              this.renderer.setStyle(node, 'transition', 'transform 200ms ease');
              this.renderer.setStyle(node, 'transform', 'translateX(0)');
            });
          }
        });
      };

      snapshot();

      this.observer = new MutationObserver(() => {
        animate();
        setTimeout(snapshot, 200);
      });

      this.observer.observe(native, {
        childList: true,
        subtree: false
      });
    });
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
